import React from 'react'
import { Box, Typography, Button } from 'components'
import { makeStyles } from '@material-ui/core'
import ThumbUpIcon from '@material-ui/icons/ThumbUp'

const useStyles = makeStyles(theme => ({
  sectionContainer: {
    backgroundColor: 'white',
    border: '1px solid #DDD',
    borderRadius: 10,
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3)
  },
  heading: {
    fontWeight: '600',
    marginBottom: theme.spacing(1)
  },
  introText: {
    fontSize: '0.9rem',
    marginBottom: theme.spacing(2)
  },
  recommendationItem: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: '1px solid #f0f0f0'
  },
  thumbsUpIcon: {
    fontSize: '1.8rem',
    color: theme.palette.primary.main,
    marginRight: theme.spacing(2)
  },
  recommenderInfo: {
    display: 'flex',
    flexDirection: 'column'
  },
  recommenderName: {
    fontWeight: 500
  },
  companyName: {
    color: theme.palette.text.secondary,
    fontSize: '0.85rem'
  },
  inviteText: {
    fontSize: '0.9rem',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}))

export default function FreelancerSideRecommendationsSection({ freelancer, onRecommend }) {
  const classes = useStyles()
  
  // Get recommendations from the freelancer object
  const recommendations = freelancer.recommendations || []

  return (
    <Box className={classes.sectionContainer}>
      <Typography variant="h5" className={classes.heading}>
        Recommendations
      </Typography>
      
      {recommendations.length > 0 ? (
        <>
          <Typography variant="body2" className={classes.introText}>
            The following people have worked with {freelancer.firstName} and would work with them again in the future.
          </Typography>
          
          {/* List of recommendations */}
          {recommendations.map((recommendation, index) => (
            <Box key={index} className={classes.recommendationItem}>
              <ThumbUpIcon className={classes.thumbsUpIcon} />
              <Box className={classes.recommenderInfo}>
                <Typography variant="body1" className={classes.recommenderName}>
                  {recommendation.recommenderName || 'Anonymous'}
                </Typography>
                <Typography variant="body2" className={classes.companyName}>
                  {recommendation.companyName || ''}
                </Typography>
              </Box>
            </Box>
          ))}
        </>
      ) : (
        <Typography variant="body2" className={classes.introText}>
          Be the first to recommend {freelancer.firstName}!
        </Typography>
      )}
      
      {/* Invite to recommend */}
      <Box mt={2}>
        {recommendations.length > 0 ? (
          <Typography variant="body2" className={classes.inviteText}>
            Have you worked with {freelancer.firstName} and would like to recommend them?
          </Typography>
        ) : null}
        
        <Button 
          variant="contained" 
          color="primary" 
          onClick={onRecommend}
          fullWidth
        >
          I'd like to recommend {freelancer.firstName}
        </Button>
      </Box>
    </Box>
  )
}
